export default function WhatsAppButton() {
    return (
        <button
            type="button"
            className="whatsapp-float"
            onClick={() => window.open('https://wa.me/971501227432', '_blank', 'noopener,noreferrer')}
            aria-label="Chat with us on WhatsApp"
        >
            <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
        </button>
    );
}
